module.exports = __webpack_public_path__ + "static/img/03_04_mega_tap.6410dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/03_04_mega_tap.png
// module id = ZiBy
// module chunks = 12